module.exports = __webpack_public_path__ + "static/thumbnail-690eb383ed2775bbaec918768165a48f.jpg";